module.exports = __webpack_public_path__ + "img/gray-button@2x.56950da5.png";